import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=4a82cc02&"
import script from "./Checkbox.vue?vue&type=script&lang=js&"
export * from "./Checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a82cc02')) {
      api.createRecord('4a82cc02', component.options)
    } else {
      api.reload('4a82cc02', component.options)
    }
    module.hot.accept("./Checkbox.vue?vue&type=template&id=4a82cc02&", function () {
      api.rerender('4a82cc02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/Checkbox.vue"
export default component.exports